import { userService } from "@/services/user-service";
import { useCallback, useState } from "react";

export function useUserSelection({
  defaultUsers,
}: {
  defaultUsers?: { value: string; label: string }[];
}) {
  const [companyUsers, setCompanyUsers] = useState<
    { value: string; label: string }[]
  >(defaultUsers ?? []);

  const handleSearchUsersByCompanyId = useCallback(
    async (companyId: string) => {
      const response = await userService.getUsersByCompanyId({
        companyId: Number(companyId),
      });

      setCompanyUsers(
        response.map((user) => ({
          value: user.user.id.toString(),
          label: `${user.user.first_name} ${user.user.last_name}`,
        })),
      );
    },
    [],
  );

  return {
    companyUsers,
    handleSearchUsersByCompanyId,
  };
}
